import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GROUP_TABS, type GroupTab } from '@/features/access/access-tabs';
import { GroupDetailPage } from '@/features/access/groups/group-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

export const Route = createFileRoute('/$tenant/groups/$groupId')({
  validateSearch: (search: Record<string, unknown>): { tab: GroupTab } => ({
    tab: GROUP_TABS.parse(search['tab']),
  }),
  component: GroupRoute,
});

function GroupRoute() {
  const { tenant, groupId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="members"
      crumbs={[
        { label: t('access.groups.title') },
        { label: <EntityName tenantId={tenant} kind="group" id={groupId} /> },
      ]}
    >
      <GroupDetailPage
        tenantId={tenant}
        groupId={groupId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
